module.exports = __webpack_public_path__ + "static/amazon-658659406aa0622285726e54da4fb58a.png";